module.exports = __webpack_public_path__ + "static/img/app_img.fb684ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone/page/app_img.png
// module id = 1h02
// module chunks = 1